import { MODULE_LAYOUTS } from 'bundles/cds-labs/components/Modules/ModuleLayout';

export const IMAGE_PLACEMENT = {
  TOP: 'top',
  BOTTOM: 'bottom',
  NO_IMAGE: 'noImage',
} as const;

export const IMAGE_PLACEMENT_OPTIONS = {
  TOP: 'Image above content',
  BOTTOM: 'Image below content',
  NO_IMAGE: 'Hide image',
} as const;

export const normalizeImagePlacement = (contentfulImagePlacement: string | null | undefined) => {
  switch (contentfulImagePlacement) {
    case IMAGE_PLACEMENT_OPTIONS.TOP:
      return IMAGE_PLACEMENT.TOP;

    case IMAGE_PLACEMENT_OPTIONS.BOTTOM:
      return IMAGE_PLACEMENT.BOTTOM;

    case IMAGE_PLACEMENT_OPTIONS.NO_IMAGE:
      return IMAGE_PLACEMENT.NO_IMAGE;

    default:
      return undefined;
  }
};

export const HERO_MODULE_TEXT_ALIGNMENT = {
  CENTER: 'Center',
  LEFT: 'Left',
} as const;

export const isImageFirstHorizontalLayout = (layout?: string | null) => {
  if (!layout) return false;

  return [
    MODULE_LAYOUTS.image2text10,
    MODULE_LAYOUTS.image3text9,
    MODULE_LAYOUTS.image4text8,
    MODULE_LAYOUTS.image5text7,
    MODULE_LAYOUTS.image6text6,
    MODULE_LAYOUTS.image7text5,
    MODULE_LAYOUTS.image8text4,
    MODULE_LAYOUTS.image9text3,
    MODULE_LAYOUTS.image10text2,
  ].includes(layout);
};

export const getIsSideBySideLayout = (layout?: string | null) => {
  if (!layout) return false;

  return (
    layout !== MODULE_LAYOUTS.textTopImageBottom &&
    layout !== MODULE_LAYOUTS.imageTopTextBottom &&
    layout !== MODULE_LAYOUTS.noImage
  );
};
